module.exports = __webpack_public_path__ + "img/chevron-down-blue.6f71e41a.svg";